<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="description" content="Nimi code signing policy: current Windows status, planned SignPath attribution, signed artifact scope, release controls, and verification instructions." />
    <meta name="theme-color" content="#0b1a19" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Code signing policy | Nimi" />
    <meta property="og:description" content="Current Windows signing status, artifact scope, release controls, and verification instructions for Nimi." />
    <meta property="og:image" content="https://nimi.ai/og-image.png" />
    <meta property="og:url" content="https://nimi.ai/code-signing" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Code signing policy | Nimi" />
    <meta name="twitter:description" content="Current Windows signing status, artifact scope, release controls, and verification instructions for Nimi." />
    <meta name="twitter:image" content="https://nimi.ai/og-image.png" />
    <link rel="canonical" href="https://nimi.ai/code-signing" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" href="/favicon.ico" sizes="any" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;600&family=Sora:wght@500;600;700&display=swap" rel="stylesheet" />
    <title>Code signing policy | Nimi</title>
    <script>
      document.documentElement.dataset.nimiScheme = 'light';
      document.documentElement.dataset.nimiAccent = 'nimi-accent';
      document.documentElement.classList.add('nimi-theme-accent--nimi-accent');
    </script>
  </head>
  <body>
    <div id="root"></div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
